import algoliasearch from 'algoliasearch'

const $algoliasearch = algoliasearch(
  process.env.ALGOLIA_APP_ID,
  process.env.ALGOLIA_API_KEY_FOR_FRONTEND,
  {
    // responsesCache: createNullCache(), // no-cache
    // requestsCache: createNullCache(), // no-cache
    // hostsCache: createNullCache() // <= 非推奨 https://www.algolia.com/doc/api-client/advanced/configure-the-client/javascript/?language=javascript#cache-on-hosts
  },
)
export default $algoliasearch
